<template>
  <div>

    <form role="form" v-if="getCriteresRanking">
      <div class="row">
        <div class="col-md-12">

          <b-alert variant="warning" show>
            <u>Attention:</u>
            <br/>
            Ce ranking n'est pas le ranking public car il est mis à jour en temps réel.<br/>
            Seul le ranking public est arrêté à chaque fin de mois.
            <br/>

          </b-alert>

          <div class="box box-primary">
            <div class="overlay" v-if="loadingTableCompetitors">
              <i class="fa fa-refresh fa-spin"></i>
            </div>

            <div class="box-header with-border">
              <h3 class="box-title">Critères de recherche</h3>
            </div>

            <div class="box-body">


              <div class="col-md-3">
                <label>N'afficher que les résultats comptabilisés au ranking actuel (résultats datant de 365 jours
                  maximum) :</label>
                <div class="form-group">
                  <label class="radio-inline">
                    <input type="radio" name="afficherRankingUnAn" id="afficherRankingUnAns"
                           value="1"
                           v-model="criteres.afficherRankingUnAn">
                    Oui
                  </label>
                  <label class="radio-inline">
                    <input type="radio" name="afficherRankingUnAn" id="afficherRankingUnAn"
                           value="0"
                           v-model="criteres.afficherRankingUnAn"
                    >
                    Non
                  </label>
                </div>

                <label>Genre :</label>
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox"
                             value="2"
                             v-model="criteres.sexe">
                      Tout
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox"

                             value="1"
                             v-model="criteres.sexe">
                      Masculin
                    </label>
                  </div>
                  <div class="checkbox">
                    <label>
                      <input type="checkbox"

                             value="0"
                             v-model="criteres.sexe">
                      Féminin
                    </label>
                  </div>
                </div>
              </div>


              <div class="col-md-3">
                <label>Catégorie d'âge :</label>
                <div class="form-group">
                  <div v-for="age in getCriteresRanking.ages" class="checkbox">
                    <label :for="'age'+age.id">
                      <input type="checkbox"
                             :id="'age'+age.id"
                             :value="age.id"
                             v-model="criteres.ages">
                      {{ age.categ_age }} ({{ age.age_min }}-{{ age.age_max }} ans)
                    </label>
                  </div>
                </div>

                <label>Grades :</label>
                <div class="form-group">
                  <div v-for="grade in getCriteresRanking.grades" class="checkbox">
                    <label>
                      <input type="checkbox"

                             :value="grade.id"
                             v-model="criteres.grade">
                      {{ grade.categ_grade }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label>Place :</label>
                <div class="form-group">
                  <div v-for="place in getCriteresRanking.places" class="checkbox">
                    <label>
                      <input type="checkbox"

                             :value="place"
                             v-model="criteres.place">
                      {{ place }}{{ place == 1 ? 'ère' : 'ème' }} place
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label>Niveau des compétitions :</label>
                <div class="form-group">
                  <div v-for="niveau in getCriteresRanking.niveaux" class="checkbox">
                    <label>
                      <input type="checkbox"

                             :value="niveau.id"
                             v-model="criteres.niveau">
                      {{ niveau.niveau }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label>Année des compétitions :</label>
                <div class="form-group">
                  <div v-for="annee in anneeDispo()" class="checkbox">
                    <label>
                      <input type="checkbox"
                             :value="annee"
                             v-model="criteres.annees">
                      {{ annee }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <label>Filtrer par compétitions particulières (<a href="#"
                                                                  @click="showAllCompetitions=!showAllCompetitions">afficher
                  toutes les compétitions</a>)</label>
                <div class="row">
                  <div class="col-md-4"
                       v-show="showAllCompetitions || index<3"
                       v-for="(arrayCompet,index) in chunkArrayInGroups(getCriteresRanking.competitions,15)">
                    <div class="form-group">
                      <div v-for="competition in arrayCompet" class="checkbox">
                        <label>
                          <input type="checkbox"

                                 :value="competition.id"
                                 v-model="criteres.competitions">
                          [{{ anneeFromDate(competition.date_debut_non_format) }}] [niv. {{ competition.id_niveau }}]
                          {{ competition.competition }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div
                      @click="getTableCompetitors()"
                      class="btn btn-primary pull-right">Rechercher
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="overlay" v-if="loadingTableCompetitors">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
            <div class="box-header with-border">
              <b-col md="7" class="my-1">
                <h3 class="box-title">{{ competitorsFound.length }} compétiteurs</h3>

              </b-col>
              <b-col md="3" class="my-1 ">
                <b-form-input v-model="filter" style="height: 28px;" placeholder="Rechercher..."></b-form-input>
              </b-col>
              <b-col md="2" class="my-1 float-right">
                <button @click.prevent="exportToExcel()" type="button" class="btn btn-primary btn-sm pull-right"
                        :disabled="competitorsFound.length==0 || disabledBtnExport"
                        :class="{'disabled':competitorsFound.length==0}">Exporter
                  en XLS/CSV (Excel)
                </button>
              </b-col>
            </div>
            <div class="box-body">

              <b-table
                id="tableListingStageFormations"
                responsive bordered striped hover
                :items="competitorsFound"
                :fields="columns"
                :filter="filter"
                :current-page="pagination_meta.current_page"
                :per-page="pagination_meta.per_page"
                :sort-compare="sortCompareAdvanced"
                :empty-text="'Aucun résultat'"
                :empty-filtered-text="'Aucun résultat'"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                foot-clone
                show-empty
              >

                <template slot="id" slot-scope="row">
                  {{ row.item.id | idFormat }}
                </template>

                <template slot="nom" slot-scope="row">
                  <router-link
                    target="_blank"
                    :to="{ name: 'Member', params: { member_id: row.item.id },query: {active_tab:'competitions'}}">
                    {{ row.item.nom }}
                  </router-link>
                </template>

                <template slot="prenom" slot-scope="row">
                  <router-link
                    target="_blank"
                    :to="{ name: 'Member', params: { member_id: row.item.id },query: {active_tab:'competitions'}}">
                    {{ row.item.prenom }}
                  </router-link>
                </template>

                <template slot="dob" slot-scope="row">
                  {{ row.item.date_naissance }}
                </template>

                <template slot="club" slot-scope="row">
                  <router-link :to="{ name: 'Club', params: { club_id: row.item.club.id }}">
                    {{ row.item.club.club }}
                  </router-link>
                </template>

                <template slot="age" slot-scope="row">
                  {{ row.item.age }}
                </template>

                <template slot="statut_age" slot-scope="row">
                  {{ getStatutAgeFromDob(row.item.date_naissance) }}
                </template>

                <template slot="compte_compet" slot-scope="row">
                  {{ row.item.compte_compet }}
                </template>

                <template slot="somme_cbts_eff" slot-scope="row">
                  {{ +row.item.somme_cbts_eff }}
                </template>

                <template slot="somme_cbts_gagnes" slot-scope="row">
                  {{ +row.item.somme_cbts_gagnes }}
                </template>

                <template slot="localPoints" slot-scope="row">
                  {{ row.item.localPoints }}
                </template>

                <template slot="totalPoints" slot-scope="row">
                  {{ row.item.totalPoints }}
                </template>

                <template slot="avg_compet" slot-scope="row">
                  {{ row.item.avg_compet }}
                </template>

                <template slot="medailles" slot-scope="row">
                  <div style="min-width:50px;"
                       v-for="(medaille, key) in sortMedaillesByKey(row.item.medailles)"
                       :key="key"
                       class="medal"
                  >
                    <template v-if="key == 'or' && medaille > 0">
                      <a href="#anchor" class="linkMedaille">
                        <i class="icons icon-or"/>
                        {{ medaille }}
                      </a>
                    </template>

                    <template v-if="key == 'arg' && medaille > 0">
                      <a href="#anchor" class="linkMedaille">
                        <i class="icons icon-argent"/>
                        {{ medaille }}
                      </a>
                    </template>


                    <template v-if="key == 'brz' && medaille > 0">
                      <a href="#anchor" class="linkMedaille">
                        <i class="icons icon-bronze"/>
                        {{ medaille }}
                      </a>
                    </template>
                  </div>
                </template>

                <template
                  slot="categPoids"
                  slot-scope="row"
                >
                  <div
                    style="min-width:150px"
                    v-for="categ in groupCategPoids(row.item.categPoids)"
                    :key="
                                                row.item.meta_url +
                                                row.item.place +
                                                categ.id_categ_poids +
                                                categ.id_categ_grade +
                                                categ.id_categ_age
                                            "
                  >
                    {{ getAgeById(categ.id_categ_age).categ_age }}
                    {{
                      getGradeById(categ.id_categ_grade) ? getGradeById(categ.id_categ_grade).categ_grade.replace('Catégorie', '') : ''
                    }}
                    {{ getPoidsById(categ.id_categ_poids).poids }}
                    ({{ categ.compte }}x)
                    <br/>
                  </div>
                </template>
              </b-table>

              <b-pagination size="md"
                            :total-rows="competitorsFound.length"
                            v-model="pagination_meta.current_page"
                            :per-page="pagination_meta.per_page">
              </b-pagination>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import vSelect from '../../Communs/vSelect/index'
import _ from 'lodash'

let $ = require('jquery');
let variables = require('../../../assets/js/variables')
// var _ = require('underscore')
let moment = require('moment')
let FileSaver = require('file-saver');

export default {
  data() {
    return {
      loadingInputs: [],
      criteres: {
        sexe: [],
        age: [],
        ages: [],
        grade: [],
        place: [],
        niveau: [],
        annees: [],
        afficherRankingUnAn: 1,
        competitions: []
      },
      disabledBtn: false,
      resize: false,
      loadingTable: false,
      activeTab: "default",
      redraw: "",
      loadingCriteresBox: false,
      loadingTableCompetitors: false,
      previousRequest: false,
      competitorsFound: [],
      competitorsSelected: [],
      sortBy: 'place',
      sortDesc: false,
      showAllCompetitions: false,
      disabledBtnExport: false,
      filter: null,
      pagination_meta: {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 45,
        to: 1,
        total: 1
      },
      columns: [
        // {
        //   label: 'Check',
        //   key: 'check',
        //   sortable: true,
        // },
        {
          label: 'Place',
          key: 'place',
          sortable: true,
        },
        {
          label: 'Nom',
          key: 'nom',
          sortable: true,
        },
        {
          label: 'Prénom',
          key: 'prenom',
          sortable: true,
        },
        {
          label: 'Date de naissance',
          key: 'dob',
          sortable: false,
        },

        {
          label: 'Age',
          key: 'age',
          sortable: true,
        },
        {
          label: 'Statut age',
          key: 'statut_age',
          sortable: false,
        },
        {
          label: 'Cat. Poids',
          key: 'categPoids',
          sortable: true,
        },
        {
          label: 'Médailles',
          key: 'medailles',
          sortable: true,
        },
        {
          label: 'Club',
          key: 'club',
          sortable: true,
        },
        {
          label: 'Nombre de compétitions',
          key: 'compte_compet',
          sortable: true,
        },
        {
          label: 'Nombre de combats effectués',
          key: 'somme_cbts_eff',
          sortable: true,
        },
        {
          label: 'Nombre de combats gagnés',
          key: 'somme_cbts_gagnes',
          sortable: true,
        },
        {
          label: 'Moyenne par compétition',
          key: 'avg_compet',
          sortable: true,
        },
        {
          label: 'Points dans ce ranking',
          key: 'localPoints',
          sortable: true,
        },
        {
          label: 'Points au ranking ABFT',
          key: 'totalPoints',
          sortable: true,
        },
        // {
        //   label: 'Actions',
        //   key: 'actions',
        // },
      ],
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getNiveauxCompetition: 'getNiveauxCompetition',
      getCriteresRanking: 'getCriteresRanking'
    }),
  },
  mounted: function () {
    let these = this
  },
  created() {
    this.getTableCompetitors();
  },
  beforeRouteEnter(to, from, next) {
    this.getTableCompetitors();
    next()
  },
  watch: {},
  components: {
    vSelect,
  },
  methods: {
    ...mapActions({
      // setFormation: 'setFormation',
      // addMemberToSMS: 'addMemberToSMS',
    }),
    exportToExcel: function () {
      if (this.competitorsFound.length == 0)
        return
      let these = this;
      let exportData = {
        "headers": [
          "Place",
          "Nom",
          "Prénom",
          "Date de naissance",
          "Age",
          "Statut age",
          "Cat. Poids",
          "Médailles",
          "Club",
          "Nombre de compétitions",
          "Nombre de combats effectués",
          "Nombre de combats gagnés",
          "Moyenne par compétition",
          "Points dans ce ranking",
          "Points au ranking ABFT",
        ],
        "data": this.competitorsFound.map((item) => {
          let medailles = _.map(these.sortMedaillesByKey(item.medailles), (medaille, index) => {
            return index + ": " + medaille
          }).join(', ')

          let catPoids = "";

          this.groupCategPoids(item.categPoids).forEach(categ => {
            let grade = this.getGradeById(categ.id_categ_grade) ? this.getGradeById(categ.id_categ_grade).categ_grade.replace('Catégorie', '') : ''
            catPoids +=
              this.getAgeById(categ.id_categ_age).categ_age + " " +
              grade + " " +
              this.getPoidsById(categ.id_categ_poids).poids + " " +
              "(" + categ.compte + "x)"+"\n"
          })

          return [
            item.id,
            item.nom,
            item.prenom,
            item.date_naissance,
            item.age,
            this.getStatutAgeFromDob(item.date_naissance),
            catPoids,
            medailles,
            item.club.club,
            item.compte_compet,
            item.somme_cbts_eff,
            item.somme_cbts_gagnes,
            item.avg_compet,
            item.localPoints,
            item.totalPoints,
          ]
        })
      }

      this.disabledBtnExport = true;
      this.loadingTableCompetitors = true

      this.$http.post(this.getRoute('Ranking.exportRankingPublicExcel'), {tableExport: exportData}, {responseType: 'blob'}).then((response) => {
        this.loadingTableCompetitors = false
        this.disabledBtnExport = false
        let blob = new Blob([response.body], {type: 'application/vnd.ms-excel'});
        FileSaver.saveAs(blob, "Ranking.xlsx");
        return response.blob();
      }, (response) => {
        this.$noty.error("Erreur dans l'export")
        this.disabledBtnExport = false
        this.loadingTableCompetitors = false
      });
    },
    getStatutAgeFromDob: function (dob) {
      switch (moment(dob, "DD/MM/YYYY").year()) {
        case (this.currentYear() - 9):
          return 'Minime première année'
        case (this.currentYear() - 11):
          return 'Minime dernière année'
        case (this.currentYear() - 12):
          return 'Cadet première année'
        case (this.currentYear() - 14):
          return 'Cadet dernière année'
        case (this.currentYear() - 15):
          return 'Junior première année'
        case (this.currentYear() - 16):
          return 'Junior dernière année'
        case (this.currentYear() - 17):
          return 'Senior première année'
        default:
          return '-'
      }


    },

    anneeFromDate: function (date_debut_non_format) {
      return moment(date_debut_non_format).format('Y')
    },
    anneeDispo: function () {
      let annees = _.sortBy(this.getCriteresRanking.competitions, 'date_debut_non_format');
      annees = annees.map(function (item, index, array) {
        let annee = moment(item.date_debut_non_format).format('Y')
        // console.log(item)
        return +annee
      })
      // debugger
      // debugger
      // if (_.indexOf(annees, +(moment().format('Y'))) < 0)
      //   annees.push(+(moment().format('Y')))
      return _.uniq(annees).reverse()
    },
    sortMedaillesByKey: function (medailles) {
      return {
        "or": medailles['or'],
        "arg": medailles['arg'],
        "brz": medailles['brz']
      }
    },
    groupCategPoids: function (allCategs) {
      let retour = {}
      let groupe = _.groupBy(allCategs, item => {
        return (
          item.id_categ_poids +
          '*' +
          item.id_categ_age +
          '*' +
          item.id_categ_grade
        )
      })

      _.forEach(groupe, (item, index) => {
        retour[index] = {}
        retour[index]['id_categ_poids'] = groupe[index][0].id_categ_poids
        retour[index]['id_categ_age'] = groupe[index][0].id_categ_age
        retour[index]['id_categ_grade'] = groupe[index][0].id_categ_grade
        retour[index]['compte'] = groupe[index].length
      })
      // debugger
      retour = _.orderBy(
        retour,
        item => {
          return item.compte
        },
        ['desc']
      )
      return retour
    },
    getAgeById: function (id) {
      return _.find(this.getCriteresRanking.ages, item => {
        return item.id == id
      })
    },
    getPoidsById: function (id) {
      if (!_.find(this.getCriteresRanking.poids, item => {
        return item.id == id
      }))
        console.log(id)
      return _.find(this.getCriteresRanking.poids, item => {
        return item.id == id
      })
    },
    getGradeById: function (id) {
      return _.find(this.getCriteresRanking.grades, item => {
        return item.id == id
      })
    },
    sortCompareAdvanced: function (a, b, key) {
      return this.$sortCompareAdvanced(a, b, key)
    },

    selectAllNiveaux() {

    },
    chunkArrayInGroups(arr, size) {
      let myArray = [];
      for (let i = 0; i < arr.length; i += size) {
        myArray.push(arr.slice(i, i + size));
      }
      return myArray;
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    currentYear: function () {
      return moment().year();
    },
    constructForm: function () {
      return {
        sexes: this.criteres.sexe,
        ages: this.criteres.ages,
        grades: this.criteres.grade,
        places: this.criteres.place,
        niveaux: this.criteres.niveau,
        competitions: this.criteres.competitions,
        annees: this.criteres.annees,
        afficherRankingUnAn: this.criteres.afficherRankingUnAn,
      }
    },
    getTableCompetitors: function () {
      this.disabledBtn = true;
      this.loadingTableCompetitors = true
      let self = this;
      let form = this.constructForm();
      // console.log(form)
      this.$http.post(this.getRoute('Ranking.getRankingIntranet'), form,
        {
          before(request) {
            // abort previous request, if exists
            if (this.previousRequest) {
              this.previousRequest.abort();
            }
            // set previous request on Vue instance
            this.previousRequest = request;
            this.loading = true
          }
        }
      ).then(function (response) {
        this.competitorsFound = response.body
        this.loadingTableCompetitors = false
      }, (response) => {
        this.$noty.error("Erreur dans la recherche")
        this.loadingTableCompetitors = false
      });
    },
    isTableCompetitorsLoading: function (force = false) {
      if (force)
        return true
      return this.loadingTableCompetitors;
    },

  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Ranking/RankingCompetitors.vue